// Application Configuration
// All environment variables are centralized here with sensible defaults
// The app will always run even if environment variables are not set

// Default configuration values
const DEFAULTS = {
  APP_NAME: 'CA-Evaluate',
  APP_VERSION: '1.0.0',
  APP_ORGANIZATION: 'Cloud Ambassadors',
  DATA_ASSESSMENT_URL: 'https://tinyurl.com/ca-data-assessment',
  LOGICAL_ASSESSMENT_URL: 'https://tinyurl.com/ca-logical-assessment',
  CLOUD_ASSESSMENT_URL: 'https://tinyurl.com/ca-cloud-assessment',
};

export const config = Object.freeze({
  // Application Info
  app: Object.freeze({
    name: process.env.REACT_APP_NAME || DEFAULTS.APP_NAME,
    version: process.env.REACT_APP_VERSION || DEFAULTS.APP_VERSION,
    organization: process.env.REACT_APP_ORGANIZATION || DEFAULTS.APP_ORGANIZATION,
  }),

  // Assessment Links
  assessments: Object.freeze({
    data: Object.freeze({
      dataML: process.env.REACT_APP_DATA_ASSESSMENT_URL || DEFAULTS.DATA_ASSESSMENT_URL,
      logical: process.env.REACT_APP_LOGICAL_ASSESSMENT_URL || DEFAULTS.LOGICAL_ASSESSMENT_URL,
    }),
    cloud: Object.freeze({
      cloud: process.env.REACT_APP_CLOUD_ASSESSMENT_URL || DEFAULTS.CLOUD_ASSESSMENT_URL,
      logical: process.env.REACT_APP_LOGICAL_ASSESSMENT_URL || DEFAULTS.LOGICAL_ASSESSMENT_URL,
    }),
  }),
});

export default config;

